var $ = jQuery = require('jquery');
var Pikaday = require('./pikaday');

angular.module('blc').controller('search_ctrl', search_ctrl);
search_ctrl.$inject = ['$scope', '$element', '$compile', 'search', 'cars', 'quote', 'currency_srv'];
function search_ctrl($scope, $element, $compile,  search, cars, quote, currency_srv) {
  $scope.element = $element;
  $scope.cars = cars;
  $scope.search = search.search;
  $scope.quote = quote;
  $scope.selected_car = cars.find_by_prop('prototype_id', quote.car_id) || null;
  $scope.quote = quote;
  $scope.cars_limit = 4;
  $scope.quote = quote;
  $scope.search = search;
  $scope.order_car = function (car) { return parseInt(car.rank_c); }
  $scope.current_date = null;
  $scope.categories_add = [];
  $scope.brand_add = [];
  $scope.page_tilte = "Availability results";

  
  $scope.currency = currency_srv;

  $scope.$watch('search.price_asc', update_cars);
  $scope.$watch('selected_car',      watch_selected_car, 1);// show 2.5 car info popup

  $scope.filter_fit = function(car) {
    return Math.random() > .7;
  }
  $scope.filter_add = function(car) {
    var weight=0;
    car.categories_ordered.forEach(function(index){
      if(!index.brand) {
        weight += ($scope.categories_add[index.name] || 0);
      }
      else {
        weight += ($scope.brand_add[index.name] || 0);
      }
    })

    if( search.check_passenger[0] != 999 && car.seats == 2) { weight += 1000; }
    if( search.check_passenger[1] != 999 && car.seats == 4) { weight += 1000; }
    if( search.check_passenger[1] != 999 && car.seats >  4) { weight += 100;  }
    if( search.check_passenger[2] != 999 && car.seats == 5) { weight += 1000; }
    if( search.check_passenger[2] != 999 && car.seats >  5) { weight += 100;  }
    // if( search.check_passenger[3] != 999 && car.seats >= 7) { weight += 1000; }


    return weight;

    if(search.price_asc){
      weight -= car.price;
    }
    else {
      weight += car.price;
    }

  }
  $scope.remove_tag = function ($event) {
    delete(search.brands[$($event.target).text()]);
    delete(search.categories[$($event.target).text()]);
    delete($scope.search.brands[$($event.target).text()]);
    delete($scope.search.categories[$($event.target).text()]);
  }

  $scope.quote_this_car = function() {
    quote.car = this.car;
    show_quote_form();
  }

  $scope.toggle_edit_search = function() {
    $scope.element.find('.search-info').toggleClass('edit');    
  }
  function update_categories_ranks(curr,old){
    $scope.categories_add = {};
    Object.keys($scope.search.categories).forEach(function(cat) {
      $scope.categories_add[cat] = 100000;
    })
    update_cars();
  }
  
  $scope.cars_for_chemodans = function(n) {
    var count = 0, i=0;
    for (i;i<$scope.cars.length;i++) {
      if ($scope.cars[i].chemodans>=n) count++;
    }
    return count;
  }
  $scope.cars_for_passengers = function(n) {
    var count = 0, i=0;
    for (i;i<$scope.cars.length;i++) {
      if ($scope.cars[i].seats>=n) count++;
    }
    return count;
  }

  function update_brands_ranks(curr, old){
    $scope.brand_add = {};
    Object.keys($scope.search.brands).forEach(function(brd) {
      $scope.brand_add[brd] = 100000;
    })
    update_cars();
  }

  function update_cars() {
    var i, car, ncars = $scope.cars.length;
    for (i=1;i<ncars;i++) {
      car = $scope.cars[i];
      car.rank_c = search.car_weight(car) + $scope.filter_add(car);
    }
    $scope.cars.sort(function(a,b) {
      return a.rank_c > b.rank_c ? -1 : 1;
    });
    setTimeout(move_separator, 100);
  }

  function move_separator() {
    var i, diff = 0, car, ncars = $scope.cars.length, car_id = 42;
    var prev_rank = $scope.cars[0].rank_c;
    for (i=1;i<ncars;i++) {
      diff = $scope.cars[i].rank_c - prev_rank;
      if (Math.abs(diff)>200) {
        prev_rank = $scope.cars[i].rank_c;
        car_id = i - 1;
      }
    }
    var last_car = $scope.element.find('.stage_two_car_block:eq(' + car_id + ')');
    last_car.after($scope.element.find('.separator'));
  }
  
  function watch_selected_car(curr, old) {
    if (curr==old) return ; // init
    if (!curr) { $.magnificPopup.close(1); return; }
    quote.car = curr;

    if (isMobile()) {
      location.href = '/' + curr.path;
      return;
    }

    $.magnificPopup.open({
      mainClass: 'mfp-fade',
      removalDelay: 400,
      overflowY: 'scroll',
      callbacks: {
        open: function() {

        },
        close: function(force) {
          if (force) return ;
          $scope.$apply(function() {
            quote.clear_car();
            $scope.selected_car = null;
          })
        }
      },
      items: [
        {
          type: 'inline',
          src: '#car_info_popup'
        }
      ]
    })
  }
  
  var step_height = 800, next_step = 500;
  window.addEventListener('scroll', function() {
    if (!scrol.up() && window.scrollY>next_step) {
      $scope.cars_limit += 4;
      next_step += step_height;
      setTimeout(function() { $(window).trigger('fake_scroll'); }, 1000);
    }
  });

}





/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/search_ctrl.js
 ** module id = 27
 ** module chunks = 0
 **/